module.exports = __webpack_public_path__ + "img/job_booking09.e61f9725.png";